var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"title":_vm.ad.name}},[_c('a',{attrs:{"href":_vm.ad.PathRedirectUrl,"target":"_blank"}},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":!_vm.isLarge ? _vm.ad.PathUrl : _vm.ad.PathUrlLarge,"alt":_vm.ad.name}})])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-736164d4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/BaseAds.vue
// module id = 2ObI
// module chunks = 0